module.exports = __webpack_public_path__ + "static/media/finance.37d0b155.png";